import JsEncrypt from 'jsencrypt'
import { KJUR, KEYUTIL, hex2b64, b64tohex } from 'jsrsasign'
// import {rsaConfig} from '@/config'

const ALGORITHM = 'SHA1withRSA'

export const rsa = {

    encryptString(sourceString,serverPublicKey) {
        let encrypt = new JsEncrypt()
        encrypt.setPublicKey(serverPublicKey)
        let data = encrypt.encrypt(sourceString)
        return data
    },
    decryptString(encryptString,clientPrivateKey) {
        let encrypt = new JsEncrypt()
        encrypt.setPrivateKey(clientPrivateKey)
        let data = encrypt.decrypt(encryptString)
        return data
    },
    signString(sourceString,clientPrivateKey) {
        const signature = new KJUR.crypto.Signature({ 'alg': ALGORITHM })
        const priKey = KEYUTIL.getKey('-----BEGIN PRIVATE KEY-----\n' + clientPrivateKey + '\n-----END PRIVATE KEY-----') // 因为后端提供的是pck#8的密钥对，所以这里使用 KEYUTIL.getKey来解析密钥
        signature.init(priKey) // 初始化实例
        signature.updateString(sourceString) // 传入待签明文
        const a = signature.sign() // 签名, 得到16进制字符结果
        return hex2b64(a) // 转换成base64
    },
    /**
     * 公钥验签
     * @param signString 明文
     * @param data 经过私钥签名并且转换成base64的结果
     * @return {Boolean} 是否验签成功
     * @constructor
     */
    verfySignString(signString, data,serverPublicKey) {
        const signature = new KJUR.crypto.Signature({ 'alg': ALGORITHM, 'prvkeypem': '-----BEGIN PUBLIC KEY-----\n' +serverPublicKey + '\n-----END PUBLIC KEY-----' })
        signature.updateString(signString) // 传入待签明文
        return signature.verify(b64tohex(data))
    }


}